import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

// Services
import { AuthService } from "../../shared/services/auth.service";

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  loading = false;
  model: any = {};
  message: string = "";
  userId: string = "";
  email: string = "";

  constructor(private route: ActivatedRoute, private authService: AuthService) {
   
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.userId = params['userId'];
      this.email = params['email'];
      if(this.userId != "" && this.email != "") {
        this.sendVerifyCode(this.userId, this.email);
      }
    });
  }

  // Send Verification Code
  sendVerifyCode(userId, email) {
    this.loading = true;
    this.model.userId = userId;
    this.model.email = email;
    this.authService.userVerify(userId, email)
        .subscribe(() => {
          this.message = "Your email has been verified successfully.";
          this.loading = false;
        }, () => {
          this.message = "";
          this.loading = false;
        });
  }

}
